<template>
    <div class="header-box">
        <a-layout-header>
            <div class="header-right">
                <a-space :size="20">
                    <div>
                        <a-dropdown placement="bottom">
                            <a>
                                <a-avatar :size="28" :src="imgPath"></a-avatar>
                                <span class="header-text">{{ userInfo.username }}</span>
                            </a>
                            <template #overlay>
                                <a-menu>
                                    <a-menu-item v-if="userInfo.type != 1 && (userInfo.status == 4 || userInfo.status == -1)">
                                        <a @click="toUserCenter()">个人中心</a>
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.type != 1 && (userInfo.status == 4 || userInfo.status == -1)">
                                        <a @click="changePassword()">修改密码</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="toExitLogin()">退出系统</a>
                                    </a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>
                    </div>
                </a-space>
            </div>
        </a-layout-header>
        <a-modal
            v-model:open="passwordOpen"
            centered
            :width="600"
            :keyboard="false"
            :maskClosable="false"
            @cancel="passwordCancel()"
        >
            <template #title>
                <div>修改密码</div>
            </template>
            <template #footer>
                <a-button @click="passwordCancel()">取消</a-button>
                <a-button type="primary" @click="passwordSave()">确认</a-button>
            </template>
            <div class="password-form">
                <a-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" :label-col="labelCol" labelAlign="left">
                    <a-form-item name="newPassword" :colon="false">
                        <template #label>
                            <div class="required-field">
                                <span>新密码</span>
                                <span class="text-red-required">*</span>
                            </div>
                        </template>
                        <a-input-password v-model:value="passwordForm.newPassword" placeholder="请输入新密码" size="large" />
                    </a-form-item>
                    <a-form-item name="confirmPassword" :colon="false">
                        <template #label>
                            <div class="required-field">
                                <span>再次输入新密码</span>
                                <span class="text-red-required">*</span>
                            </div>
                        </template>
                        <a-input-password v-model:value="passwordForm.confirmPassword" placeholder="请再次输入新密码" size="large" />
                    </a-form-item>
                    <a-form-item name="phone" :colon="false">
                        <template #label>
                            <div class="required-field">
                                <span>手机号</span>
                                <span class="text-red-required">*</span>
                            </div>
                        </template>
                        <a-input v-model:value="passwordForm.phone" size="large" readonly />
                    </a-form-item>
                    <a-form-item name="smsCode" :colon="false">
                        <template #label>
                            <div class="required-field">
                                <span>短信验证码</span>
                                <span class="text-red-required">*</span>
                            </div>
                        </template>
                        <a-flex gap="10" align="center" justify="space-between">
                            <a-input v-model:value="passwordForm.smsCode" size="large" placeholder="请输入短信验证码" />
                            <a-button size="large" @click="sendSmsCode">{{ smsCodeButtonText }}</a-button>
                        </a-flex>
                    </a-form-item>
                </a-form>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from "vue-router";
import { apiClient } from '@/utils/axios';
import { message } from 'ant-design-vue';

// 路由数据
const router = useRouter();
// 用户数据
const imgPath = ref(require('@/assets/icons/menus/user-2.png'));//头像
const userInfo = reactive({
    type: '',//用户类型
    username: '',//用户名
    status: '',//用户状态
});//用户信息
// 修改密码
const passwordOpen = ref(false);//修改密码弹窗
const passwordFormRef = ref(null);//密码表单
const passwordForm = reactive({
    newPassword: '',//新密码
    confirmPassword: '',//确认密码
    smsCode: '',//短信验证码
    phone:'',//手机号
});
const labelCol = {
    style: {
        width: '120px',
    },
};
// 短信验证码按钮文本
const smsCodeButtonText = ref('获取验证码');
// 密码验证
const validatePass = async (_rule, value) => {
    if (value === '') {
        return Promise.reject('请输入密码');
    } else if (value.length < 8 || value.length > 20) {
        return Promise.reject("密码长度必须在8-20个字符之间");
    } else if (!/[0-9]/.test(value)) {
        return Promise.reject("密码必须包含数字");
    } else if (!/[a-zA-Z]/.test(value)) {
        return Promise.reject("密码必须包含字母");
    } else if (!/[^0-9a-zA-Z]/.test(value)) {
        return Promise.reject("密码必须包含特殊符号");
    } else {
        if (passwordForm.confirmPassword !== '') {
            passwordFormRef.value.validateFields('confirmPassword');
        }
        return Promise.resolve();
    }
};
// 再次输入密码验证
const validatePassSure = async (_rule, value) => {
    if (value === '') {
        return Promise.reject('请再次输入密码');
    } else if (value != passwordForm.newPassword) {
        return Promise.reject("两次输入密码不一致");
    } else {
        return Promise.resolve();
    }
};
// 短信验证码验证
const validateSmsCode = async (_rule, value) => {
    if (value === '') {
        return Promise.reject('请输入短信验证码');
    } else {
        return Promise.resolve();
    }
};
// 验证规则
const passwordRules = {
    newPassword: [
        {
            validator: validatePass,
            trigger: 'change',
        },
    ],
    confirmPassword: [
        {
            validator: validatePassSure,
            trigger: 'change',
        },
    ],
    smsCode: [
        {
            validator: validateSmsCode,
            trigger: 'change',
        },
    ],
};

// 获取用户信息
const getUserInfo = () => {
    let name = localStorage.getItem('name');
    let enterprise_name = localStorage.getItem('enterprise');
    let contact = localStorage.getItem('contact');
    userInfo.type = localStorage.getItem("type");
    userInfo.status = localStorage.getItem("status");
    if (userInfo.type=='1') {
        userInfo.username = name;
    } else {
        userInfo.username = enterprise_name==null?enterprise_name:contact;
    }
};
// 跳转用户中心
const toUserCenter = () => {
    router.push({ name: "userCenter" }); //菜单栏路由跳转
};
// 修改密码
const changePassword = () => {
    passwordOpen.value = true;
    passwordForm.phone = localStorage.getItem('phone') || '';
};
// 取消修改密码
const passwordCancel = () => {
    passwordFormRef.value.resetFields();//重置表单
    passwordOpen.value = false;
};
// 获取短信验证码
const sendSmsCode = () => { 
    if (passwordForm.phone.length < 11) {
        message.warning('请输入手机号');    
        return;
    }
    let postParams = {
        mobile: passwordForm.phone,
    }
    apiClient.post('/auth/sms_code/', postParams)
    .then((response) => {
        if (response.data.code == '200') {
            message.success(response.data.msg||response.data.message);
            // 验证码按钮倒计时
            smsCodeButtonText.value = '60秒后重新获取';
            let countdown = 60;
            const timer = setInterval(() => {
                countdown--;
                smsCodeButtonText.value = `${countdown}秒后重新获取`;
                if (countdown <= 0) {
                    clearInterval(timer);
                    smsCodeButtonText.value = '获取验证码';
                }
            }, 1000);
        } else {
            message.error(response.data.msg||response.data.message);
        }
    }).catch(error => {
        message.error(error);
    });
};
// 保存修改密码
const passwordSave = () => {
    passwordFormRef.value.validate()
    .then(() => {
        passwordSubmit();
    })
    .catch(error => {
        console.log('error', error);
    });
};
// 提交修改密码
const passwordSubmit = () => {
    let postData={
        sms_code: passwordForm.smsCode,
        password: passwordForm.newPassword,
        verify_password: passwordForm.confirmPassword,
    }
    apiClient.post('/my/change_password/', postData)
        .then(response => {
        if(response.data.code === 200){
            message.success(response.data.msg);
            passwordCancel();
        }else{
            message.error(response.data.msg);
        }
    })
    .catch(error => {
        message.error(error);
    });
};
// 退出登录
const toExitLogin = () => {
    // 清除浏览器存储信息---全部清除
    localStorage.clear();
    sessionStorage.clear();
    // window.location.href = url.api.OA_URL;//退出之后返回oa系统
    router.replace({ name: "login" }); //菜单栏路由跳转
};

onMounted(() =>{
    // 获取用户信息
    getUserInfo();
});

onBeforeUnmount(() => {

});
</script>

<style lang="scss" scoped>
.header-box{
    z-index: 2;
}
.ant-layout .ant-layout-header{
    background: transparent;
    height: 66px;
    line-height: 66px;
    padding-inline: 20px;
}
.header-right{
    text-align: end;
    .header-text{
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        letter-spacing: -0.01px;
        color: #606266;
        margin-left: 7px;
        position: relative;
        top: 2px;
    }
}
/* 下拉菜单 */
.ant-dropdown .ant-dropdown-menu{
    border-radius: 6px;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid #E4E7EE;
    margin-top: 10px;
}
.ant-dropdown .ant-dropdown-menu {
    max-height: 300px; /* 设置你想要的高度 */
    overflow-y: auto; /* 启用垂直滚动条 */
}
// 修改密码
.password-form{
    padding: 32px 40px 17px 40px;
    .required-field{
        font-size: 14px;
        font-weight: normal;
        letter-spacing: -0.01px;
        color: #303133;
    }
}
:deep(.ant-form-item ){
    margin-bottom: 15px;
}
:deep(.ant-form-item .ant-form-item-label >label ){
    height: 40px;
}
</style>